import { AuthService } from '../services/auth.service';
import { Enums } from './../common/enums';
import { MessageService } from '../services/message.service';
import { Message } from '../common/message';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { UserService } from '../services/user.service';
import { User } from '../models/user';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

  form: FormGroup;
  submitted = false;
  success = false;
  resource: User = new User();

  constructor(
    private enums: Enums,
    private dialog: MatDialog,
    private service: UserService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private msg: MessageService) { }

  ngOnInit() {
    this.setMessageForm();
    this.getUserData()
  }


  setMessageForm() {
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      role: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  onSave() {

    this.submitted = true;

    if (!this.resource || !this.resource.password || this.resource.password.trim() == '') {
      return;
    }

    if (this.form.controls.password.errors) {
      return;
    }

    if (this.resource.id) {
      this.updateElement();
    }

  }

  updateElement() {
    this.service.update(this.resource)
      .subscribe(result => {
        this.msg.alert(Message.UPDATE);
        this.authService.logout();
      })
  }

  getUserData() {
    let ele = this.authService.getUserData();
    this.resource.setId(ele.id);
    this.resource.setName(ele.name);
    this.resource.setEmail(ele.email);
    this.resource.setRole(ele.role);
    this.resource.setActive(ele.active);
  }

}

